<div *ngIf="groupValues.length > 0 && groupZoneDescriptors.length > 0">
  <div class="box card-box row m-x-xs" *ngFor="let value of groupValues">
    <div class="box-header">
      <h3>{{value.groupDescriptor.transId | translate}}</h3>
    </div>
    <div class="box-body">
      <gp-generated-simple-form
        [id]="cliRegId"
        [readOnly]="true"
        [isEditMode]="false"
        [groupZoneDescriptor]="value.groupDescriptor"
        [values]="value">
      </gp-generated-simple-form>
    </div>
  </div>
</div>
<div *ngIf="!isOnboardingTask()">
  <h4 class="title" *ngIf="!loading">{{'NOTIFICATIONS.current_employee_data' | translate}}</h4>
  <div *ngIf="existingGroupValues?.length === 0" class="alert alert-warning text-center">
    {{"CHARTS.no_data" | translate}}
  </div>
  <div *ngIf="existingGroupValues?.length > 0 && groupZoneDescriptors?.length > 0">
    <div class="box card-box row m-x-xs opacity-7" *ngFor="let value of existingGroupValues">
      <div class="box-header flex-between">
        <h3>{{value.groupDescriptor.transId | translate}}</h3>
        <span *ngIf="value.groupDescriptor.isDated"
              class="p-r-sm"
              tooltip="{{ value.validRangeLabel | translate}}"
              placement="left">
        <em class="fa fa-light fa-calendar-check fa-lg" aria-hidden="true"></em>
      </span>
      </div>
      <div class="box-body">
        <gp-generated-simple-form
          [id]="cliRegId"
          [readOnly]="true"
          [isEditMode]="false"
          [groupZoneDescriptor]="value.groupDescriptor"
          [values]="value">
        </gp-generated-simple-form>
      </div>
    </div>
  </div>
</div>


